import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalConsumptionDto } from "../dto/solar-proposal-consumption.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** The selected consumption, its lock and Green Button availability. A pure read. */
export default function useSolarProposalConsumption(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalConsumptionDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.consumption(proposalId ?? ``),
    queryFn: () => solarProposalService.getConsumption(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
